import React from "react";
import "./AlertPopUp.scss";
import { images } from "../../constants";

const AlertPopUp = ({ msg, type }) => {
  return (
    <div className="alert-pop-up">
      <div className={`content ${type === 200 ? "bg-Success " : "bg-Error"}`}>
        {type === 200 ? (
          <img src={images.IconSuccess} alt="icon-" />
        ) : (
          <img src={images.IconAlert} alt="icon-" />
        )}

        <p className={` ${type === 200 ? "text-Success" : "text-Error"}`}>
          {msg}
        </p>
      </div>
    </div>
  );
};

export default AlertPopUp;
